import { styled } from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const EmptyOffersContainer = styled.div`
  padding-block: 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImageContainer = styled.div`
  margin-block-end: 2rem;
  height: 6.25rem;
  width: 7.4375rem;
`;

export const EmptyTitle = styled.div`
  font-family: ${Styles.fontFamily.brand};
  font-weight: 400;
  letter-spacing: normal;
  margin-block-end: 0.5rem;
  text-align: center;
  line-height: 1.125rem;
  font-size: 1.125rem;

  ${Styles.desktop} {
    line-height: 1.75rem;
    font-size: 1.5rem;
  }
`;

export const EmptyDescription = styled.div`
  font-family: ${Styles.fontFamily.body};
  font-weight: 400;
  letter-spacing: normal;
  margin-block-end: 1rem;
  text-align: center;
  font-size: 1rem;
  line-height: 1.25rem;

  ${Styles.desktop} {
    font-size: 1.125rem;
    line-height: 1.25rem;
  }
`;

export const EmptyCTAContainer = styled.button`
  border: 0;
  background: ${primitive.bk.$fieryRed};
  padding: 0.5rem 1rem;
  border-radius: 50rem;
  cursor: pointer;
`;

export const EmptyCTAText = styled.span`
  color: ${primitive.$white};
  font-family: ${Styles.fontFamily.brand};
  font-weight: 400;
  letter-spacing: normal;
  font-size: 0.875rem;
  line-height: 1.125rem;

  ${Styles.desktop} {
    font-size: 1rem;
    line-height: 1.5rem;
  }
`;
